import { useContext, useEffect, useState } from 'react';
import { OtherBoutikServicesContext } from '../../context/otherBoutikServices/otherBoutikServicesContext';
import { ProductReviews } from '../../models/productReviews';
import { ReviewsService } from '../../interfaces/services/reviewsService';
import { Maybe } from '../../engine/apis/magento2/types.generated';

export const useProductReviews = (
    sku?: string | Maybe<string>
): ProductReviews | undefined => {
    const servicesContext = useContext(OtherBoutikServicesContext);
    const reviewsService = servicesContext['ReviewsService'] as ReviewsService;

    const [productReviews, setProductReviews] = useState<ProductReviews>();

    useEffect(() => {
        if (sku) {
            reviewsService
                .getReviewsBySku(sku)
                .then((productReviews: ProductReviews | null) => {
                    if (productReviews) {
                        setProductReviews(productReviews);
                    }
                })
                .catch((e) => console.error(e));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sku]);

    return productReviews;
};